import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from './App';
import { AppContextProvider } from '../context';
import UseApolloClient from '@bit/bluekeel.hookz.use-apollo-client';
import { ApolloProvider } from '@apollo/react-hooks';
import UsePushProsScripts from '@bit/bluekeel.hookz.use-push-pros-scripts';
import UseSentry from '@bit/bluekeel.hookz.use-sentry';
import Radium, { StyleRoot } from 'radium';
// fontawesome
import initFontAwesome from '../utils/initFontAwesome';
initFontAwesome();

const history = createBrowserHistory();

const Global = () => {
	UsePushProsScripts('https://pushpros.tech/GetPushScript?key=2Xa3N8H4tIMDq5DaLOjgimHq4HG8UhWO&domain=');
	UseSentry({ 
		history,
		dsn: 'https://dc3d0f1addbc4d83a1cabb4343463f71@o440028.ingest.sentry.io/5425972',
		page: 'perfect-credit-match',
		version: '0.0.1'
	});

	const apolloUri = 'https://cbvb02ezl4.execute-api.us-east-1.amazonaws.com/prod/graphql';
	// const apolloTest = 'https://cypmxq177b.execute-api.us-east-1.amazonaws.com/test/graphql';
	// const apolloLocal = 'http://localhost:4000/graphql';

	const client = UseApolloClient(apolloUri);

	const WrappedApp = Radium(App);

	return (
		<ApolloProvider client={client}>
			<AppContextProvider>
				<Router history={history}>
					<StyleRoot>
						<WrappedApp />
					</StyleRoot>
				</Router>
			</AppContextProvider>
		</ApolloProvider>
	);
}


export default Global;